import { render, staticRenderFns } from "./SendEmailForNewFeature.vue?vue&type=template&id=2567d784&scoped=true&"
import script from "./SendEmailForNewFeature.vue?vue&type=script&lang=ts&"
export * from "./SendEmailForNewFeature.vue?vue&type=script&lang=ts&"
import style0 from "./SendEmailForNewFeature.vue?vue&type=style&index=0&id=2567d784&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2567d784",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2567d784')) {
      api.createRecord('2567d784', component.options)
    } else {
      api.reload('2567d784', component.options)
    }
    module.hot.accept("./SendEmailForNewFeature.vue?vue&type=template&id=2567d784&scoped=true&", function () {
      api.rerender('2567d784', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/SendEmailForNewFeature.vue"
export default component.exports